import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'je-information',
  templateUrl: './information.component.html',
  styleUrls: ['./information.component.scss']
})
export class InformationComponent {

  constructor(
    public dialogRef: MatDialogRef<InformationComponent>) { }

  onOkClick(): void {
    this.dialogRef.close();
  }
}